import clsx from "clsx";
import { PITCH_CATEGORY_COLORS } from "@/lib/pitchCategoryColors";

export interface CategoryColorPickerProps {
  value: string;
  onChange: (color: string) => void;
  disabled?: boolean;
}

export function CategoryColorPicker({ value, onChange, disabled }: CategoryColorPickerProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {PITCH_CATEGORY_COLORS.map((option) => (
        <button
          key={option.value}
          type="button"
          disabled={disabled}
          title={option.label}
          aria-label={option.label}
          className={clsx(
            "h-7 w-7 rounded-full border-2 transition-transform",
            value === option.value
              ? "scale-110 border-label shadow-sm"
              : "border-transparent hover:scale-105",
            disabled && "cursor-not-allowed opacity-60",
          )}
          style={{ backgroundColor: option.value }}
          onClick={() => onChange(option.value)}
        />
      ))}
    </div>
  );
}
